import { useContext, useRef } from 'react';
import { interfaces } from 'inversify';

import { InversifyContext } from './ServiceProvider';

function useLazyRef<T>(resolveValue: () => T): T {
  const ref = useRef<{ v: T }>();
  if (!ref.current) {
    ref.current = { v: resolveValue() };
  }
  return ref.current.v;
}

export function useContainer(): interfaces.Container;
export function useContainer<T>(resolve: (container: interfaces.Container) => T): T;
export function useContainer<T>(
  resolve?: (container: interfaces.Container) => T,
): interfaces.Container | T {
  const { container } = useContext(InversifyContext);
  if (!container) {
    throw new Error('Не удается найти контейнер Inversify в React Context.');
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return resolve ? useLazyRef(() => resolve(container)) : container;
}

export function useInjection<T>(serviceId: interfaces.ServiceIdentifier<T>): T {
  return useContainer(container => container.get<T>(serviceId));
}
